module.exports = __webpack_public_path__ + "img/hand-thumbs-up-fill.81059ae4.svg";